import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AtriconLayoutComponent } from './layout/atricon-layout/atricon-layout.component';
import { Page404Component } from './features/authentication/page404/page404.component';
import { AbastecimentoLayoutComponent } from './layout/abastecimento-layout/abastecimento-layout.component';
import { authTokenGuard } from './core/guards/auth-token/auth-token.guard';
import { authRoleGuard } from './core/guards/auth-role/auth-role.guard';

const routes: Routes = [
  { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
  {
    path: 'controlador',
    canActivate: [authTokenGuard],
    component: AtriconLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/controlador/controlador.module').then((m) => m.ControladorModule),
      }
    ]
  },
  {
    path: 'adm',
    canActivate: [authTokenGuard, authRoleGuard],
    data: { expectedRole: 'ACESSO_IMAP' },
    loadChildren: () =>
      import('./features/area-administrativa/area-administrativa.module').then(
        (m) => m.AreaAdministrativaModule
      )
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'abastecimento',
    canActivate: [authTokenGuard],
    component: AbastecimentoLayoutComponent,
    loadChildren: () =>
      import('./features/abastecimento/abastecimento.module').then(
        (m) => m.AbastecimentoModule
      ),
  },
  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'disabled',
  }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
